(function ($) {

  'use strict';

  if($('#search').length > 0) {
    $('#search').autocomplete({
      minLength : 3,
      source: getAutocompleteSource('/vyhledavani.html'),
      select: handleSelection
    }).data('ui-autocomplete')._renderItem = renderAutocompleteItem;

    function handleSelection (event, ui) {
      window.location.href = ui.item.link;
      return false;
    }

    function getAutocompleteSource (url) {

      return getData;

      function getData (req, res) {

        $.ajax({
          type: 'GET',
          dataType: 'xml',
          minLength: 3,
          url: url,
          data: {
            query: req.term,
            ajax: 1
          },
          success: handleSuccessfulResponse(res),
          error: handleError
        });
      }

      function handleSuccessfulResponse (res) {

        return function (data) {

          var results = [];
          var items = $('item', data);

          items.forEach((item) =>
          results.push({
            link: [ $('link', item).text() ],
            title: [ $('title', item).text() ],
            perex: [ $('perex', item).text() ],
            icon: [$('icon', item).text()]
          })
        );

        res(results);
      };
    }

      function handleError (response) {
        console.log(response);
      }
    }

    function renderAutocompleteItem (ul, item) {

      var li = $('<li/>').data('item.autocomplete', item);

      $('<a/>', {
        href: item.link,
        html: [
          '<img class="ui-item-icon" src="/sys/images/file-type/' + item.icon + '.png" />',
          '<strong>' + item.title + '</strong>',
          '<div class="ui-item-perex">' + (item.perex || '') + '</div>'
        ].join('')
      }).appendTo(li);

      return li.appendTo(ul);
    }

  }

})(jQuery);
